// src/utils/mvpCalculations.js
import { didPlayerWin } from './achievementCalculations';

export function computeMonthlyMVP(players, matches) {
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  // 이번 달 공식 경기만 필터
  const monthMatches = matches.filter(m => {
    if (m.match_category === 'friendly') return false;
    const d = new Date(m.date);
    return d.getMonth() === currentMonth && d.getFullYear() === currentYear;
  });

  if (monthMatches.length === 0) return null;

  // 선수별 월간 통계
  const stats = {};
  monthMatches
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .forEach(match => {
      const ids = [match.player1_id, match.player2_id, match.player3_id, match.player4_id].filter(Boolean);
      ids.forEach(pid => {
        if (!stats[pid]) stats[pid] = { wins: 0, losses: 0, ratingChange: 0, matchCount: 0 };
        stats[pid].matchCount++;
        if (didPlayerWin(match, pid)) stats[pid].wins++;
        else stats[pid].losses++;
        if (match.rating_changes?.[pid]?.change) {
          stats[pid].ratingChange += match.rating_changes[pid].change;
        }
      });
    });

  const entries = Object.entries(stats);
  const findPlayer = (id) => players.find(p => String(p.id) === String(id));

  // Elo 상승왕
  const ratingEntry = [...entries].sort((a, b) => b[1].ratingChange - a[1].ratingChange)[0];
  const ratingKing = ratingEntry && ratingEntry[1].ratingChange > 0
    ? { player: findPlayer(ratingEntry[0]), value: ratingEntry[1].ratingChange }
    : null;

  // 승률왕 (최소 3경기)
  const winRateEntry = [...entries]
    .filter(([, s]) => s.matchCount >= 3)
    .sort((a, b) => (b[1].wins / b[1].matchCount) - (a[1].wins / a[1].matchCount))[0];
  const winRateKing = winRateEntry
    ? { player: findPlayer(winRateEntry[0]), value: Math.round((winRateEntry[1].wins / winRateEntry[1].matchCount) * 100) }
    : null;

  // 다승왕
  const matchEntry = [...entries]
    .filter(([, s]) => s.wins > 0)
    .sort((a, b) => b[1].wins - a[1].wins)[0];
  const matchKing = matchEntry
    ? { player: findPlayer(matchEntry[0]), value: matchEntry[1].wins }
    : null;

  return {
    month: `${currentYear}년 ${currentMonth + 1}월`,
    ratingKing,
    winRateKing,
    matchKing,
  };
}
